import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { InventoryModel, InventoryPaths } from 'client/data/models/inventory';
import { AdTargetingPrefetch } from 'site-modules/shared/components/native-ad/inventory-ad-targeting/ad-targeting';

export const InventoryAdTargetingPrefetch = connectToModel(AdTargetingPrefetch, {
  adTargeting: bindToPath(InventoryPaths.getAdTargeting(), InventoryModel),
});
InventoryAdTargetingPrefetch.displayName = 'InventoryAdTargetingPrefetch';
